<mat-form-field [appearance]="appearance" class="fk-w-full fk-relative">
  <!-- * --------------- label ------------------ ^ -->

  <mat-label class="fk-px-3">
    <base-form-kit-label
      [label]="label"
      [hasCurrency]="hasCurrency"
      [currency]="currency"
    >
      <ng-content select="[label-content]"></ng-content>
    </base-form-kit-label>
  </mat-label>

  <input
    matInput
    [type]="isShowPassword ? 'text' : type"
    [formControl]="control || defaultControl"
    [placeholder]="placeholder"
    [ngStyle]="{
      'font-size': fontSize
    }"
    [ngClass]="{
      'fk-text-right': textAlign == 'right',
      'fk-text-left': textAlign == 'left',
      'fk-text-center': textAlign == 'center',
      'fk-dir-ltr': isLtr||isOnlyNumber,
      'fk-dir-rtl': !isLtr&&!isOnlyNumber,
    }"
    [class]="'fk-px-10px' + ' ' + classList"
    [ngModel]="value | numberSeparator : hasNumberSeparator"
    [cursorPointer]="hasNumberSeparator ? true : false"
    (ngModelChange)="value = $event"
    [onlyNumbers]="isOnlyNumber"
    [step]="step"
    [maxlength]="maxLength"
    [minlength]="minLength"
    [max]="max"
    [min]="min"
    [readonly]="isReadOnly"
    [attr.autocomplete]="isAutoComplete ? null : 'new-password'"
    (input)="emitValue()"
    (input)="emitInputEvent($event)"
    (change)="emitChangeEvent($event)"
  />

  <ng-content select="[content]"></ng-content>

  <!-- * --------------- prefix suffix ------------------ ^ -->

  <div class="fk-items-center" matSuffix>
    <!-- password icon  -->
    <div *ngIf="type == 'password'" class="fk-mx-2 fk-relative">
      <i
        (click)="isShowPassword = !isShowPassword"
        class="mdi mdi-24px fk-cursor-pointer fk-text-gray-800 fk-text-gray-600 fk-pl-1"
        [ngClass]="{
          'mdi-eye': isShowPassword,
          'mdi-eye-off': !isShowPassword
        }"
      ></i>
    </div>

    <validation-icon
      [control]="control"
      [hasMatPrefix]="hasMatPrefix"
      [hasMatSuffix]="hasMatSuffix"
      [value]="value"
      [isShowValidationStatusIcon]="isShowValidationStatusIcon"
    >
    </validation-icon>
  </div>

  <!-- prefix content -->
  <div
    matPrefix
    class="fk-relative"
    [style.display]="hasMatPrefix ? 'block' : 'none'"
  >
    <div #prefixContent>
      <ng-content select="[prefix-content]"></ng-content>
    </div>
  </div>

  <!-- suffix content -->
  <div
    matSuffix
    class="fk-mx-2 fk-relative"
    [style.display]="hasMatSuffix ? 'block' : 'none'"
  >
    <div #suffixContent>
      <ng-content select="[suffix-content]"></ng-content>
    </div>
  </div>
</mat-form-field>

<!-- validation-errors -->
<validation-errors
  class="fk-w-full"
  [label]="label"
  [min]="min"
  [max]="max"
  [minLength]="minLength"
  [maxLength]="maxLength"
  [control]="control || defaultControl"
  [inputChangeEvent]="inputChangeEvent"
></validation-errors>
